var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimCards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 432V96C21.49 96 0 117.492 0 144V448C0 483.344 28.654 512 64 512H304C330.51 512 352 490.508 352 464H80C62.326 464 48 449.672 48 432ZM336 0H160C124.75 0 96 28.75 96 64V352C96 387.25 124.75 416 160 416H384C419.25 416 448 387.25 448 352V112L336 0ZM240 144H304V192H240V144ZM160 176C160 158.25 174.25 144 192 144H208V192H160V176ZM208 352H192C174.25 352 160 337.75 160 320V304H208V352ZM304 352H240V304H304V352ZM384 320C384 337.75 369.75 352 352 352H336V304H384V320ZM384 272H160V224H384V272ZM384 192H336V144H352C369.75 144 384 158.25 384 176V192Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimCards);
export default __webpack_public_path__ + "static/media/sim-cards.9828caaca657824363c32f1f36eb762e.svg";
export { ForwardRef as ReactComponent };